export default function PHP_fgets() {
  return (
    <div>
      <h1>PHP_fgets</h1>
    </div>
  );
}
